import { AnimatedBackground } from "components/AnimatedBackground";
import CenteredFooter from "examples/Footers/CenteredFooter";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import { Box, Container, Divider, Grid } from "@mui/material";
import MKTypography from "components/MKTypography";
import { CONTACT_EMAIL, TICKER } from "utils/constants";

const privacySections = [
  {
    title: "What Information We Collect",
    description:
      "When you visit our site, we automatically collect basic details such as your web browser, IP address, time zone, and cookies. We may use services like Google Analytics and Firebase Analytics to collect anonymous usage data through cookies and similar technologies. If you make a purchase, we may collect additional information like your billing details and wallet address.",
  },
  {
    title: "How We Use Your Data",
    description:
      "We use your data to process transactions, prevent fraud, improve our site, and provide updates about FartLab. Your information helps us deliver the best experience and keep FLART running smoothly.",
  },
  {
    title: "Sharing Your Information",
    description:
      "We don’t sell your data. However, we may share it with trusted third-party services like Google Analytics and Firebase Analytics to understand site usage. We might also disclose information if required by law or during major business changes like a merger or acquisition.",
  },
  {
    title: "Advertising & Tracking",
    description:
      "We use Google Analytics and Firebase Analytics to help understand how users interact with our platform. We may use cookies and these third-party services to show you relevant ads. If you'd like to opt out of targeted advertising, check the settings on platforms like Google or Facebook. Note: We don’t alter data collection based on 'Do Not Track' browser settings.",
  },
  {
    title: "Your Rights",
    description:
      "If you’re in the EU, you have rights to access, update, or delete your data. Contact us if you’d like to make a request.",
  },
  {
    title: "Data Retention",
    description:
      "We keep your data only as long as necessary for transactions and legal requirements. If you’d like your data deleted, just reach out.",
  },
  {
    title: "For Minors",
    description:
      "FartLab is not meant for users under 18. If you’re underage, please ask a legal guardian before using our site.",
  },
  {
    title: "Changes to This Policy",
    description:
      "We may update this privacy policy as needed. Any changes will be posted here, so check back if you're curious.",
  },
  {
    title: "Contact Us",
    description: `If you have any questions or requests about your data, you can reach us at ${CONTACT_EMAIL}.`,
  },
];

function PrivacyPage() {
  return (
    <>
      {/* Navbar */}
      <DefaultNavbar
        routes={[]}
        // action={{
        //   type: "internal",
        //   route: "#",
        //   label: `Buy ${TICKER}`,
        //   color: "primary",
        //   disabled: true,
        // }}
        transparent
        light
      />

      {/* Main Container */}
      <AnimatedBackground
        gradients={[
          ["#4ac29a", "#bdfff3"],
          ["#6ee2f5", "#6454f0"],
        ]}
      >
        <Container sx={{ mt: "20vh", mb: "15vh", textAlign: "center" }}>
          <Grid container spacing={10} justifyContent="center">
            {/* Discord Card */}
            <Grid item xs={12} md={7}>
              {/* Privacy Title */}
              <MKTypography
                variant="h1"
                fontWeight="bold"
                color="white"
                sx={{
                  fontSize: "80px",
                  textShadow: "3px 3px black",
                  blackSpace: "pre-line",
                  letterSpacing: 1.5,
                  mb: 5,
                }}
              >
                Privacy Policy
              </MKTypography>

              {/* Intro Text */}
              <MKTypography
                variant="h5"
                color="white"
                sx={{
                  textShadow: "2px 2px black",
                  blackSpace: "pre-line",
                  letterSpacing: 1.5,
                  mb: 10,
                }}
              >
                Your privacy matters. Here’s how we collect, use, and protect your information.
              </MKTypography>

              {/* Privacy Sections */}
              {privacySections.map((section, index) => (
                <Box key={index} sx={{ textAlign: "left", mb: 5 }}>
                  <MKTypography
                    variant="h3"
                    color="white"
                    fontWeight="bold"
                    sx={{
                      textShadow: "2px 2px black",
                      letterSpacing: 1,
                      mb: 1,
                    }}
                  >
                    {section.title}
                  </MKTypography>
                  <MKTypography
                    variant="body1"
                    color="white"
                    sx={{
                      textShadow: "1px 1px black",
                    }}
                  >
                    {section.description}
                  </MKTypography>

                  {/* Divider Between Sections */}
                  {index < privacySections.length - 1 && (
                    <Divider sx={{ my: 4, border: "3px solid black", opacity: 0.6 }} />
                  )}
                </Box>
              ))}
            </Grid>
          </Grid>
        </Container>

        {/* Footer */}
        <CenteredFooter light />
      </AnimatedBackground>
    </>
  );
}

export default PrivacyPage;
